import styled from 'styled-components';
import Divider from '../../atoms/Divider';
import {TimerIcon} from '../../atoms/Icons';
import {DividerColor,SurfaceColor,Grey600} from '../../Colors';

export default {
	Wrapper : styled.div`
		position : relative;
		padding : 5px;
		border-radius : 5px;
		color : ${({color=`${Grey600}`})=>color};
`,
	Progresbar : styled.div`
		width : 100%;
		height : 10px;
		background-color : ${SurfaceColor};
		border : 1px dotted ${DividerColor};
		border-radius : 5px;
		margin-bottom : 1rem;
		position : relative;
`,
	Progress : styled.div`
		position : absolute;
		top : 0;
		left : 0;
		border-radius : 5px;
		width : ${({progress=10})=>`${progress}%`};
		height : 10px;
		background-color : ${({progress=10})=>{
		if(progress < 75 ) return 'green';
		if(progress < 90 ) return 'orange';
		return 'red';
	}};
`,
	TimerIcon : styled(TimerIcon)`
		font-size : 4rem;
		margin-right : 1rem;
	`,
	Min : styled.span`
		font-size : 4rem;
	`,
	Sec : styled.span`
		font-size : 1.5rem;
	`,
	Divider,

};